import { Button } from "@/components/flexkit/Button";
import { EmptyStateCard } from "@/components/podkit/EmptyStateCard";
import { SecretLabels } from "@/components/secrets/secret-labels";
import { SecretsTable } from "@/components/secrets/SecretsTable";
import { type PlainSecret } from "@/queries/secret-queries";
import { type SecretScope } from "gitpod-next-api/gitpod/v1/secret_pb";
import { type FC, type PropsWithChildren } from "react";

type Props = {
    scope: SecretScope;
    secrets: PlainSecret[];
    onNewSecret: () => void;
    showCreatorColumn?: boolean;
};
export const SecretsCard: FC<Props> = ({ scope, secrets, onNewSecret, showCreatorColumn = true }) => {
    if (secrets.length === 0) {
        return <SecretsEmptyState scope={scope} onNewSecret={onNewSecret} />;
    }

    return (
        <SecretsFrame>
            <SecretsTable secrets={secrets} onNewSecret={onNewSecret} showCreatorColumn={showCreatorColumn} />
        </SecretsFrame>
    );
};

// this is reused for showing secrets in the environment details
export const SecretsFrame: FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="flex w-full justify-center rounded-xl border border-border-base bg-surface-glass px-4 py-3">
            {children}
        </div>
    );
};

const SecretsEmptyState: FC<{ scope: SecretScope; onNewSecret: () => void }> = ({ scope, onNewSecret }) => {
    const mode = scope.scope.case === "projectId" ? "project" : "user";
    return (
        <EmptyStateCard
            title="No secrets"
            description={SecretLabels[mode].emptyStateDescription}
            data-testid="secrets-empty-state"
        >
            <Button onClick={onNewSecret} data-testid="add-secret-modal-trigger">
                New Secret
            </Button>
        </EmptyStateCard>
    );
};
